export default __webpack_public_path__ + "static/Yael Tamar-887948e6c4112ef49f7dc744e436a62f.png";